module.exports = __webpack_public_path__ + "img/webg.fcfb3d1e.webp";